import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Card, Form, Message, List } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { DateTimeInput } from "semantic-ui-calendar-react";
import moment from "moment";
import InputNumber from "rc-input-number";

//Import Actions
import { fetchRevenueTypes, insertRevenue } from "actions/inputActions";

//Import Components
import ActionButton from "components/ActionButton";

//Import Styles
import "./InputRevenueForm.scss";

function InputRevenueForm(props) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    eventtime: "",
    invoicedate: "",
    vehicle_id: 0,
    company_id: 0,
    revenuetype_id: 0,
    currency: "EUR",
    exchange: 100,
    quantity: 1,
    total: 0.0,
    vatrate: 0.0,
    vat: 0.0,
    vattotal: 0.0,
  });
  const [errorList, setErrorList] = useState([]);

  const onDropDownChanged = (e, { value, name }) => {
    setFormData({ ...formData, [name]: value });
  };
  const onDateTimeChanged = (e, { name, value }) => {
    setFormData({ ...formData, [name]: value });
  };

  // todo: exchange
  const onSaveRevenue = () => {
    let revenueData = {
      vehicle_id: formData.vehicle_id,
      company_id: formData.company_id,
      revenuetype_id: formData.revenuetype_id,
      eventtime: moment(formData.eventtime, "DD.MM.YYYY HH:mm").toJSON(),
      invoicedate: moment(formData.eventtime, "DD.MM.YYYY HH:mm").toJSON(),
      exchange: 100, // for now we set this to fixed
      currency: formData.currency,
      quantity: formData.quantity,
      total: formData.total,
      VAT_rate: formData.vatrate,
      VAT: formData.vat,
      VAT_total: formData.vattotal,
      spare1: "",
    };

    let eList = [];
    //Check the data
    if (!revenueData.eventtime) {
      eList.push(t("input.revenueform.errors.invalid_timestamp"));
    }
    /*if (revenueData.vehicle_id === 0) {
      eList.push(t("input.revenueform.errors.missing_vehicle"));
    }*/
    if (revenueData.company_id === 0) {
      eList.push(t("input.revenueform.errors.missing_company"));
    }
    if (revenueData.revenuetype_id === 0) {
      eList.push(t("input.revenueform.errors.missing_revenuetype"));
    }
    if (revenueData.currency === "") {
      eList.push(t("input.revenueform.errors.missing_currency"));
    }
    if (revenueData.total <= 0) {
      eList.push(t("input.revenueform.errors.invalid_total"));
    }
    setErrorList(eList);
    if (eList.length === 0) {
      props.addRevenue(revenueData).then((x) => {
        resetForm();
      });
    }
  };

  const onFinancialDataChanged = (value, name) => {
    let { vatvalue, vattotal } = 0;
    switch (name) {
      //automatically calculate vat value and vat total
      case "total":
        vatvalue = value * (formData.vatrate / 100);
        vattotal = vatvalue + value;
        setFormData({
          ...formData,
          vat: vatvalue,
          total: value,
          vattotal: vattotal,
        });
        break;
      case "vatrate":
        vatvalue = formData.total * (value / 100);
        vattotal = vatvalue + formData.total;
        setFormData({
          ...formData,
          vat: vatvalue,
          vatrate: value,
          vattotal: vattotal,
        });
        break;
      default:
        setFormData({ ...formData, [name]: value });
        break;
    }
  };

  const resetForm = () => {
    setFormData({
      eventtime: "",
      invoicedate: "",
      vehicle_id: 0,
      company_id: 0,
      revenuetype_id: 0,
      currency: "EUR",
      exchange: 100,
      quantity: 1,
      total: 0.0,
      vatrate: 0.0,
      vat: 0.0,
      vattotal: 0.0,
    });
  };

  useEffect(() => {
    const getRevenueTypes = async () => {
      props.getRevenueTypes();
    };
    getRevenueTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const vehicleList = props.vehicles.map((x) => {
    return { value: x.id, text: `${x.brand} - ${x.reg_number}` };
  });
  const companyList = props.companies.map((x) => {
    return { value: x.id, text: `${x.name}` };
  });
  const revenuetypesList = props.revenuetypes.map((x) => {
    return { value: x.id, text: `${x.code || ""} - ${x.name}` };
  });
  let errorMessages = <div></div>;
  if (errorList.length > 0) {
    errorMessages = (
      <Message negative>
        <Message.Header>{t("input.revenueform.errors.title")}</Message.Header>
        <List bulleted>
          {errorList.map((x, i) => {
            return <List.Item key={i}>{x}</List.Item>;
          })}
        </List>
      </Message>
    );
  }
  return (
    <Card fluid className="inputrevenueform">
      <Card.Content>
        <Card.Header>{t("input.revenueform.manualrevenue_title")}</Card.Header>
      </Card.Content>
      <Card.Content>
        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("input.revenueform.datetime_eventtime")}</label>
              <DateTimeInput
                name="eventtime"
                placeholder="Date Time"
                value={formData.eventtime}
                popupPosition="bottom center"
                clearable={true}
                dateFormat="DD.MM.YYYY"
                duration={0}
                animation="none"
                onChange={onDateTimeChanged}
              />
            </Form.Field>
            <Form.Dropdown
              required
              id="inputrevenueform-vehicle"
              label={t("input.revenueform.select_vehicle")}
              fluid
              search
              selection
              options={vehicleList}
              value={formData.vehicle_id}
              onChange={onDropDownChanged}
              lazyLoad={true}
              name="vehicle_id"
            />
            <Form.Dropdown
              required
              id="inputrevenueform-company"
              label={t("input.revenueform.select_company")}
              fluid
              search
              selection
              options={companyList}
              value={formData.company_id}
              onChange={onDropDownChanged}
              lazyLoad={true}
              name="company_id"
            />
            <Form.Dropdown
              required
              id="inputrevenueform-revenuetype"
              label={t("input.revenueform.select_revenuetype")}
              fluid
              search
              selection
              options={revenuetypesList}
              value={formData.revenuetype_id}
              lazyLoad={true}
              onChange={onDropDownChanged}
              name="revenuetype_id"
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Input
              id="inputrevenueform-currency"
              value={formData.currency}
              label={t("input.revenueform.input_currency")}
              onChange={(e, x) => onFinancialDataChanged(x.value, "currency")}
              fluid
            />
            <Form.Field>
              <label>{t("input.revenueform.input_quantity")}</label>
              <InputNumber
                step={1}
                value={formData.quantity}
                precision={0}
                onChange={(e) => onFinancialDataChanged(e, "quantity")}
              />
            </Form.Field>
            <Form.Field required>
              <label>{t("input.revenueform.input_total")}</label>
              <InputNumber
                step={0.01}
                value={formData.total}
                precision={2}
                decimalSeparator={t("decimalcomma")}
                onChange={(e) => onFinancialDataChanged(e, "total")}
              />
            </Form.Field>
            <Form.Field>
              <label>{t("input.revenueform.input_vatrate")}</label>
              <InputNumber
                step={1}
                value={formData.vatrate}
                precision={0}
                decimalSeparator={t("decimalcomma")}
                onChange={(e) => onFinancialDataChanged(e, "vatrate")}
              />
            </Form.Field>
            <Form.Field>
              <label>{t("input.revenueform.input_vat")}</label>
              <InputNumber
                step={0.01}
                value={formData.vat}
                precision={2}
                decimalSeparator={t("decimalcomma")}
                onChange={(e) => onFinancialDataChanged(e, "vat")}
              />
            </Form.Field>
            <Form.Field>
              <label>{t("input.revenueform.input_vattotal")}</label>
              <InputNumber
                step={0.01}
                value={formData.vattotal}
                precision={2}
                decimalSeparator={t("decimalcomma")}
                onChange={(e) => onFinancialDataChanged(e, "vattotal")}
              />
            </Form.Field>
          </Form.Group>
          {errorMessages}
          <ActionButton
            text={t("input.costform.button_save")}
            size="large"
            icon="save"
            onClick={onSaveRevenue}
          />
        </Form>
      </Card.Content>
    </Card>
  );
}

const mapStateToProps = (state) => ({
  vehicles: state.input.vehicles,
  companies: state.input.companies,
  revenuetypes: state.input.revenuetypes,
});
const mapDispatchToProps = (dispatch) => ({
  getRevenueTypes: () => dispatch(fetchRevenueTypes()),
  addRevenue: (revenuedata) => dispatch(insertRevenue(revenuedata)),
});
export default connect(mapStateToProps, mapDispatchToProps)(InputRevenueForm);

/*
              <NumberInput
                id="inputrevenueform-quantity"
                valueType="decimal"
                value={formData.quantity}
                buttonPlacement="leftAndRight"
                minValue={0}
                allowEmptyValue={false}
                precision={2}
                onChange={(e) => onFinancialDataChanged(e, "quantity")}
              />

*/

/*
            <Form.Field required>
              <label>{t("input.revenueform.input_total")}</label>
              <NumberInput
                id="inputrevenueform-total"
                valueType="decimal"
                value={formData.total}
                buttonPlacement="leftAndRight"
                minValue={0}
                allowEmptyValue={false}
                precision={2}
                onChange={(e) => onFinancialDataChanged(e, "total")}
              />
            </Form.Field>

                          <NumberInput
                id="inputrevenueform-vat-rate"
                valueType="decimal"
                value={formData.vatrate}
                buttonPlacement="leftAndRight"
                minValue={0}
                allowEmptyValue={false}
                precision={2}
                onChange={(e) => onFinancialDataChanged(e, "vatrate")}
              />

                            <label>{t("input.revenueform.input_vat")}</label>
              <NumberInput
                id="inputrevenueform-vat"
                valueType="decimal"
                value={formData.vat}
                buttonPlacement="leftAndRight"
                minValue={0}
                allowEmptyValue={false}
                precision={2}
                onChange={(e) => onFinancialDataChanged(e, "vat")}
              />
            </Form.Field>
            <Form.Field>
              <label>{t("input.revenueform.input_vattotal")}</label>
              <NumberInput
                id="inputrevenueform-vat-total"
                valueType="decimal"
                value={formData.vattotal}
                buttonPlacement="leftAndRight"
                minValue={0}
                allowEmptyValue={false}
                precision={2}
                onChange={(e) => onFinancialDataChanged(e, "vattotal")}
              />


*/
